// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3hWWY","productName":"Table_productName__2m7Oy"};